<template>
  <div class="modal-content" @click.stop>
    <div class="modal-header">
      <h2>Preguntas Frecuentes</h2>
      <button @click="$emit('close')" class="close-btn" aria-label="Cerrar modal">&times;</button>
    </div>
    <div class="modal-body">
      <div class="faq-tabs">
        <button
          v-for="(cat, ci) in categories"
          :key="cat.id"
          class="faq-tab"
          :class="{ 'faq-tab--active': ci === activeCategory }"
          @click="setCategory(ci)">
          <i :class="cat.icon"></i> {{ cat.name }}
        </button>
      </div>
      <div class="faq-list">
        <div
          v-for="(faq, fi) in categories[activeCategory].faqs"
          :key="fi"
          class="faq-item">
          <button class="faq-question" @click="toggle(activeCategory, fi)">
            <span>{{ faq.q }}</span>
            <i class="faq-icon fas" :class="faq.open ? 'fa-minus' : 'fa-plus'"></i>
          </button>
          <transition name="faq-slide">
            <div v-show="faq.open" class="faq-answer">
              <p>{{ faq.a }}</p>
              <ol v-if="faq.steps" class="faq-steps">
                <li v-for="(step, si) in faq.steps" :key="si">{{ step }}</li>
              </ol>
              <p v-if="faq.note" class="faq-note">{{ faq.note }}</p>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FAQ',
  emits: ['close'],
  data() {
    return {
      activeCategory: 0,
      categories: [
        {
          id: 'mercadolibre',
          name: 'Agencia Mercado Libre',
          icon: 'fas fa-store',
          faqs: [
            { q: '¿Qué es el servicio de Agencia de Mercado Libre?', a: 'Somos un punto autorizado que funciona para entrega y recepción de paquetes.', open: false },
            { q: '¿Necesito la app de Mercado Libre para usar el servicio?', a: 'Sí. La entrega y recepción de paquetes (ventas o devoluciones) se realiza por medio de la aplicación de Mercado Libre.', open: false },
            { q: '¿Puedo traer mi venta o mi devolución aquí?', a: 'Sí. Sigue estos pasos desde la app de Mercado Libre:', steps: ['Ve a Mis compras y selecciona el pedido a devolver.', 'Toca Tuve un problema y elige el motivo de la devolución.', 'Selecciona Devolver el producto y confirma los datos.', 'Mercado Libre generará un código QR en la app — tenlo listo en pantalla.', 'Trae el paquete correctamente empacado y sellado a nuestra tienda con el QR y nosotros lo escaneamos y enviamos. No se aceptan paquetes abiertos o sin sellar.'], note: 'El reembolso se procesa una vez que el vendedor recibe y aprueba la devolución. El QR tiene vigencia limitada, así que acude pronto tras generarlo.', open: false },
          ],
        },
        {
          id: 'papeleria',
          name: 'Papelería',
          icon: 'fas fa-book',
          faqs: [
            { q: '¿Qué productos de papelería tienen disponibles?', a: 'Contamos con una amplia variedad: cuadernos, libretas, carpetas, lápices, plumas, colores, marcadores, tijeras, pegamento, folders y mucho más para escuela y oficina.', open: false },
            { q: '¿Venden material para manualidades y arte?', a: 'Sí, tenemos pinturas, pinceles, papel de colores, foamy, stickers, cartulinas y otros materiales para proyectos creativos y manualidades.', open: false },
            { q: '¿Puedo hacer pedidos especiales o por mayoreo?', a: 'Por el momento no manejamos ventas por mayoreo, pero con gusto te atendemos para cualquier pedido especial. Puedes contactarnos por WhatsApp al +52 322 147 2806, por correo a contacto@neliel.mx o visitarnos directamente en tienda. ¡Estamos para ayudarte!', open: false },
          ],
        },
        {
          id: 'servicios',
          name: 'Servicios',
          icon: 'fas fa-concierge-bell',
          faqs: [
            { q: '¿Hacen impresiones y copias de documentos?', a: 'Sí, ofrecemos impresiones en blanco y negro y a color, copias y escaneos de documentos y más. Puedes traer tu archivo en USB o enviárnoslo por WhatsApp.', open: false },
            { q: '¿Las herramientas del Taller Creativo son gratuitas?', a: 'Sí, todas las herramientas del Taller Creativo (etiquetas escolares, plantillas imprimibles y más) son 100% gratuitas y las puedes usar directamente desde tu navegador, sin instalar nada.', open: false },
            { q: '¿Tienen servicio a domicilio o envíos?', a: 'Por el momento no contamos con servicio a domicilio.', open: false },
            { q: '¿Dónde están ubicados y cuál es su horario?', a: 'Estamos en Oaxaca #147, Col. Las Mojoneras, Puerto Vallarta, Jalisco. Atendemos de Lunes a Sábado de 9:00 a 21:00 hrs y los Domingos de 11:00 a 17:00 hrs.', open: false },
          ],
        },
        {
          id: 'pagos',
          name: 'Formas de Pago',
          icon: 'fas fa-credit-card',
          faqs: [
            { q: '¿Qué formas de pago aceptan en tienda?', a: 'Aceptamos efectivo, transferencia bancaria y tarjeta de crédito.', open: false },
            { q: '¿Puedo apartar un producto con un anticipo?', a: 'Sí, aceptamos anticipos para separar productos o pedidos especiales. Contáctanos por WhatsApp al +52 322 147 2806 para coordinar los detalles.', open: false },
          ],
        },
      ],
    };
  },
  methods: {
    setCategory(index) {
      this.activeCategory = index;
      this.categories.forEach(cat => cat.faqs.forEach(f => (f.open = false)));
    },
    toggle(catIdx, faqIdx) {
      const faqs = this.categories[catIdx].faqs;
      const isOpen = faqs[faqIdx].open;
      faqs.forEach(f => (f.open = false));
      if (!isOpen) faqs[faqIdx].open = true;
    },
  },
};
</script>

<style scoped>
.modal-content {
  background-color: #fff;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 5px 25px rgba(0,0,0,0.2);
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  overflow-y: auto;
  text-align: left;
  position: relative;
  font-family: var(--f-body, 'Inter', 'Poppins', sans-serif);
  color: var(--c-text, #1a1a1a);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--c-border, #e8e4df);
  padding-bottom: 15px;
  margin-bottom: 20px;
}

.modal-header h2 {
  margin: 0;
  font-family: var(--f-serif, 'Lora', serif);
  color: var(--c-primary, #003b4c);
  font-size: 1.8rem;
}

.close-btn {
  background: none;
  border: none;
  font-size: 2.5rem;
  font-weight: 300;
  line-height: 1;
  cursor: pointer;
  color: #aaa;
  transition: color 0.3s ease;
}
.close-btn:hover { color: #333; }

/* ── Tabs ── */
.faq-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 24px;
}

.faq-tab {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 7px 16px;
  border-radius: 999px;
  border: 1.5px solid var(--c-border, #e8e4df);
  background: transparent;
  font-family: var(--f-body, 'Inter', sans-serif);
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--c-text2, #4a4a4a);
  cursor: pointer;
  transition: background 0.2s, color 0.2s, border-color 0.2s;
}
.faq-tab:hover {
  border-color: var(--c-primary, #003b4c);
  color: var(--c-primary, #003b4c);
}
.faq-tab--active {
  background: var(--c-primary, #003b4c);
  border-color: var(--c-primary, #003b4c);
  color: #fff;
}

/* ── Accordion ── */
.faq-item {
  border-bottom: 1px solid var(--c-border, #e8e4df);
}
.faq-item:last-child { border-bottom: none; }

.faq-question {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: none;
  border: none;
  padding: 16px 0;
  text-align: left;
  cursor: pointer;
  font-family: var(--f-serif, 'Lora', serif);
  font-size: 1rem;
  font-weight: 600;
  color: var(--c-primary, #003b4c);
  gap: 12px;
  transition: color 0.2s;
}
.faq-question:hover { color: var(--c-coral, #ed8f7b); }

.faq-icon {
  flex-shrink: 0;
  font-size: 0.85rem;
}

.faq-answer {
  padding-bottom: 16px;
}
.faq-answer p {
  margin: 0 0 8px;
  line-height: 1.8;
  color: var(--c-text2, #4a4a4a);
  font-size: 0.95rem;
}

.faq-steps {
  margin: 8px 0 12px;
  padding-left: 20px;
  color: var(--c-text2, #4a4a4a);
  font-size: 0.95rem;
}
.faq-steps li {
  line-height: 1.8;
  margin-bottom: 6px;
}
.faq-steps li:last-child { margin-bottom: 0; }

.faq-note {
  margin: 10px 0 0 !important;
  font-size: 0.88rem !important;
  color: var(--c-text3, #7a7570) !important;
  font-style: italic;
}

/* ── Slide transition ── */
.faq-slide-enter-active,
.faq-slide-leave-active {
  transition: opacity 0.22s ease, max-height 0.28s ease;
  overflow: hidden;
  max-height: 300px;
}
.faq-slide-enter-from,
.faq-slide-leave-to {
  opacity: 0;
  max-height: 0;
}
</style>
